import { FC, useEffect, useState } from 'react'

import EmailSentPanel from 'password/EmailSentPanel'
import ForgotPasswordPanel from 'password/ForgotPasswordPanel'
import { useForgotPasswordMutation } from 'api/passwordResetsApi'
import { useAuth } from 'shared/hooks/useAuth'
import { useUser } from 'shared/hooks/useUser'

enum View {
  ForgotPassword,
  EmailSent,
}

const ForgotPassword: FC<{}> = () => {
  const [email, setEmail] = useState('')
  const [currentView, setCurrentView] = useState(View.ForgotPassword)

  const [forgotPassword, { isSuccess }] = useForgotPasswordMutation()

  const { isAuthenticated } = useUser()
  const { logoutUser } = useAuth()

  useEffect(() => {
    if (isSuccess) {
      setCurrentView(View.EmailSent)
    }
  }, [isSuccess])

  const handleBackToResetPassword = () => {
    setCurrentView(View.ForgotPassword)
  }

  const handleSubmitEmail = async emailStr => {
    setEmail(emailStr)
    const forgotPasswordBody = {
      password_resets: {
        email: emailStr,
      },
    }
    await forgotPassword(forgotPasswordBody)
    if (isAuthenticated) {
      await logoutUser()
    }
  }

  return (
    <div>
      {currentView === View.ForgotPassword ? (
        <ForgotPasswordPanel onSubmit={handleSubmitEmail} />
      ) : (
        <EmailSentPanel email={email} onBackToResetPassword={handleBackToResetPassword} />
      )}
    </div>
  )
}

export default ForgotPassword
